<template>
  <div class="card-body">
    <div class="row row-spacing">
      <div class="col-md-12">

        <div class="row align-items-center justify-content-between">
          <div class="col-md-8">
            <div class="form-row align-items-center">
              <div class="form-group col-md-6">
                <label>Search Documents</label>
                <div class="input-group"> 
                  <input type="text" class="form-control" v-model="searchText" placeholder="Filter on Description" />
                  <div class="input-group-append">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <UploadSupplierDocument 
              :supplierNumber="supplierNumber"
              :documents="documents" 
              :documentTypes="documentTypes" 
              @loadDocuments="getDocuments" 
            />
          </div>
        </div>
        <hr>

        <SupplierDocumentList 
          :supplierNumber="supplierNumber"
          :documents="filteredDocuments" 
          :documentTypes="documentTypes" 
          @loadDocuments="getDocuments" 
        />
      </div>
    </div>

  </div>
</template>

<script>
import SupplierDocumentList from '@/components/Documents/SupplierDocumentList'
import UploadSupplierDocument from '@/components/Documents/UploadSupplierDocument'
import SupplierRequiredDocumentation from '@/components/Suppliers/SupplierRequiredDocumentation'
export default {
    components: {
      SupplierDocumentList,
      UploadSupplierDocument,  
      SupplierRequiredDocumentation, 
    },
    computed: {
      filteredDocuments() {
        return this.documents.filter(c =>
          c.description.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1 ||
          c.type.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1);
      }
    },
    data: function() {
        return {
          supplierNumber: 0,
          supplier: {},
          documents: [],
          selectedDocument: {
            file: {}
          },
          emptyDocument: {},
          documentTypes: [],
          searchText: '',
        }
    },
    created() {
      this.supplierNumber = this.$route.params.supplierNumber;
      this.$root.$emit('SET_PAGE_TITLE', this.$route.meta.title);
    },
    mounted: function() {
      this.getSupplier();       
      this.getDocuments();
      this.getEmptyDocument(); 
    },
    methods: {
      getSupplier() {
        this.$http.get(this.$config.aimsAPIv3 + 'suppliers/' + this.supplierNumber)
          .then(response => {
            this.supplier = response.data;
            this.$root.$emit('SET_PAGE_TITLE', this.$route.meta.title + " - " + this.supplier.name);
          }, error => {
            console.error(error);
            this.showError('Error Fetching Supplier', error);
          })
      },
      updateSupplier() {
        this.$refs.supplierModal.isLoading();
        this.$http.put(this.$config.aimsAPIv3 + 'suppliers/update', this.supplier)
          .then(response => {
            this.getSupplier();
          }, error => {
            console.error(error);
            this.showError('Error Updating Supplier', error);
          });
      },

      getDocuments() {
        this.$http.get(this.$config.aimsAPIv3 + 'suppliers/' + this.supplierNumber + '/documents')
          .then(response => {
            this.documents = response.data;
          }, error => {
            console.error(error);
            this.showError('Error Fetching Documents', error);
          }).finally(() => {
            this.getDocumentTypes();
          });;
      },
      getDocumentTypes() {
        this.$http.get(this.$config.aimsAPIv3 + 'suppliers/document/types')
          .then(response => {
            this.documentTypes = response.data;
          }, error => {
            console.error(error);
            this.showError('Error Fetching Documents', error);
          });
      },
      getEmptyDocument() {
        this.$http.get(this.$config.aimsAPIv3 + 'suppliers/empty/document')
          .then(response => {
            this.emptyDocument = response.data;
          }, error => {
            console.error(error);
            this.showError('Error Fetching Empty Document', error);
          });
      },
      createDocument() {
        this.$http.post(this.$config.aimsAPIv3 + 'suppliers/' + this.supplierNumber + '/create/document', this.selectedDocument)
          .then(response => {
            this.selectedDocument = response.data;
          }, error => {
            console.error(error);
            this.showError('Error Creating Document', error);
          });
      },
      updateDocument() {
        this.$http.put(this.$config.aimsAPIv3 + 'suppliers/update/document', this.selectedDocument)
          .then(response => {
            this.selectedDocument = response.data;
          }, error => {
            console.error(error);
            this.showError('Error Updating Document', error);
          });
      },
      deleteDocument(documentNumber) {
        this.$http.delete(this.$config.aimsAPIv3 + 'suppliers/delete/doument/' + documentNumber)
          .then(response => {
            this.getDocuments();
          }, error => {
            console.error(error);
            this.showError('Error Deleting Document', error);
          });
      }
    }
}

</script>

